import React from 'react';
import '../styles/base.css'
import LineSpacer from './line';

function About() {
  return (
    <section className="about-container">
      <h2>About</h2>
      <LineSpacer/>
      <p>
        <br />
        Hello - I'm Kevin Chung, a Developer/Project Manager currently based in Seattle with backgrounds in computer science, data analytics, and e-commerce.
        <br /><br />
        From a young age, I've been fascinated by both fashion and technology — an interest that evolved into a deep appreciation for how products and stories are presented through digital platforms.<br/>
        <br></br>
        Having worked in fashion and e-commerce for over 10 years, I have taken on various roles, spanning from building custom web applications, redesigning websites, implementing search engine optimization (SEO) strategies, to fostering relationships with designers and producing collaborative projects.
        <br /><br />
        During my time at Blue Owl, I have led a variety of technical projects which you will find detailed in my works section below. My tech stack, combined with my education in Computer Science and Data Analytics, have equipped me to make strategic decisions based on facts and metrics.
        <br /><br />
        In my projects, I aim to convey a narrative through code and design with data serving as the foundation.<br/>
        I am deeply passionate about lifelong learning and driven by progression. As an engineer learning new-technologies has always excited me as I aim to better my craft everyday. The ability to learn in both life and work has proven to keep me grounded in every step I take.
        <br /><br />
        I am extremely grateful to have developed a handful of meaningful connections through my proffesional endeavors. Some of the brands and people I've worked with include Engineered Garments, Merz b. Schwannen, Dehen 1920, Good Art Hollywood, Kaptain Sunshine, Addict Clothes Japan, UES, and South2 West8. 
        <br /><br />
        When I'm not working on projects or coding you can find me spending time with my family and our pets Miso and Gamja. We enjoy basketball, photography, and sunny days.
        <br /><br />
        Feel free to shoot me a message with any questions. Happy to chat about anything, whether it's fashion, tech, or anything in between!
      </p>
    </section>
  );
}

export default About;